var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMore = function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.333,
    cy: 9.999,
    r: 1.167,
    fill: "#181818",
    transform: "rotate(-90 5.333 10)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.999,
    r: 1.167,
    fill: "#181818",
    transform: "rotate(-90 10 10)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.667,
    cy: 9.999,
    r: 1.167,
    fill: "#181818",
    transform: "rotate(-90 14.667 10)"
  })));
};
export default SvgIconMore;